<template>
  <div>
    <a-modal
      title="添加资源"
      :visible="visible"
      :mask-closable="false"
      :width="550"
      :confirm-loading="loading"
      destroy-on-close
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <a-radio-group
        name="radioGroup"
        :default-value="1"
      >
        <a-radio
          :value="1"
          @focus="chooseFirst"
        >
          添加资源包
        </a-radio>
        <a-radio
          :value="2"
          @focus="chooseSec"
        >
          添加产品
        </a-radio>
        <div
          v-if="productVision"
          class="select-width"
        >
          <span>请选择添加产品类型：</span>
          <a-select
            label-in-value
            placeholder="请选择添加产品类型"
            show-search
            :options="productTypetions"
            @change="changeProductType"
            :filter-option="filterOption"
          />
        </div>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import {
  queryAllProductTypes
} from '@/api/common.js'
// import { addResource } from '@/api/resourceSetting.js'
import { filterOption } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      productVision: false,
      resourceType: '1',
      product: {
        productTypeId: '',
        productTypeName: ''
      },
      configData: {}
    }
  },
  created () {
    this.fetchSearchOptions()
  },
  methods: {
    filterOption,
    async fetchSearchOptions () {
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data.map((item) => {
          return {
            label: item.productTypeName,
            value: item.productTypeId
          }
        })
      })
    },
    handleCancel () {
      this.chooseFirst()
      this.$emit('typeCancel')
    },
    handleOk () {
      this.$emit('typeOk', this.resourceType, this.product)
      this.chooseFirst()
    },
    chooseFirst (e) {
      this.productVision = false
      this.resourceType = '1'
    },
    chooseSec (e) {
      this.productVision = true
      this.resourceType = e.target.value
    },
    changeProductType (value) {
      this.product.productTypeId = value.key
      this.product.productTypeName = value.label
    }
  }
}
</script>
<style lang="less" scoped>
.select-width {
  margin: 30px;

  .ant-select {
    width: 200px;
  }
}
</style>
